import React from 'react'
import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'

import { P, Text, TextField } from '@mxenabled/mxui'

import { Dialog, useGlobalCopyStore } from '../../../common'

import { useEvent, useTransactionStore } from '../../../common'
import { ON_CLICK_EVENTS } from '../../constants/OnClickEvents'

const Header = () => {
  const theme = useTheme()

  const { onEvent } = useEvent()
  const { addTag } = useTransactionStore()
  const { transactions: copy } = useGlobalCopyStore()

  const [isAdding, setIsAdding] = React.useState(false)
  const [tagName, setTagName] = React.useState('')
  const [tagNameError, setTagNameError] = React.useState('')

  const inputRef = React.useRef<HTMLInputElement>(null)

  React.useEffect(() => {
    if (isAdding) {
      inputRef?.current?.focus()
    }
  }, [isAdding])

  const handleAdding = () => {
    onEvent(
      isAdding
        ? ON_CLICK_EVENTS.ON_TRANSACTION_TAGS_TAG_ADD_CANCEL_CLICK
        : ON_CLICK_EVENTS.ON_TRANSACTION_TAGS_TAG_ADD_CLICK,
    )
    if (!isAdding) {
      setTagName('')
    }
    setIsAdding(!isAdding)
  }

  const handleAddTag = async () => {
    onEvent(ON_CLICK_EVENTS.ON_TRANSACTION_TAGS_TAG_ADDED)
    await addTag(tagName)
    setIsAdding(false)
  }

  React.useEffect(() => {
    setTagNameError(tagName.length > 40 ? copy.tags_error_name_must_be_40_chars : '')
  }, [tagName])

  return (
    <Box className="mx-txn-tag-manager-header">
      <Stack
        alignItems="center"
        bgcolor={theme.palette.background.default}
        direction="row"
        justifyContent="space-between"
        px={24}
        py={16}
      >
        <Text bold={true}>{copy.tags_your_tags}</Text>
        <Button
          aria-expanded={isAdding}
          aria-label={copy.tags_add_tag_btn_aria}
          onClick={handleAdding}
        >
          {copy.tags_add_tag_btn}
        </Button>
      </Stack>

      <Dialog
        copy={{ title: copy.tags_add_tag_btn }}
        isOpen={isAdding}
        onClose={() => setIsAdding(false)}
        onPrimaryAction={handleAddTag}
        onSecondaryAction={() => setIsAdding(false)}
      >
        <TextField
          aria-label={copy.tags_placeholder}
          name="add-tag"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTagName(e.target.value)}
          placeholder={copy.tags_placeholder}
          sx={{ width: '100%' }}
          value={tagName}
        />
        <P id="add-tag-error" sx={{ color: 'error.main' }} variant="subtitle2">
          {tagNameError}
        </P>
      </Dialog>
    </Box>
  )
}

export default observer(Header)
